module.exports = __webpack_public_path__ + "img/category_22.7688e949.png";